import type { EventIncidentType, EventType } from "app/types/eventType";
import IceHockeyPhaseDeadBall from "./components/IceHockeyPhaseDeadBall/IceHockeyPhaseDeadBall";
import IceHockeyPhaseLive from "./components/IceHockeyPhaseLive/IceHockeyPhaseLive";
import "./IceHockeyPhase.scss";

function IceHockeyPhase(props: { eventData: EventType }) {
  const { eventData } = props;
  const eventIncidents: EventIncidentType[] = eventData["eventIncidents"];
  const eventPhase: string = eventIncidents[0]["eventPhase"];
  const quarterPhase: boolean = eventPhase.includes("PERIOD");
  //
  return quarterPhase ? (
    <IceHockeyPhaseLive
      eventIncidents={eventIncidents}
      eventPhase={eventPhase}
    />
  ) : (
    <IceHockeyPhaseDeadBall
      eventIncidents={eventIncidents}
      eventPhase={eventPhase}
    />
  );
}
export default IceHockeyPhase;
